var map = {
	"./grade-management-2DGC_desktop.json": 6941,
	"./grade-management-2DGC_mobile.json": 3103,
	"./grade-management-2DGG_desktop.json": 1107,
	"./grade-management-2DGG_mobile.json": 9318,
	"./grade-management-3DGG_desktop.json": 3071,
	"./grade-management-3DGG_mobile.json": 4453,
	"./grade-management-3DSG_desktop.json": 7613,
	"./grade-management-3DSG_mobile.json": 5039,
	"./obstacle-intelligence_desktop.json": 5556,
	"./obstacle-intelligence_mobile.json": 7548,
	"./operations-management_desktop.json": 2129,
	"./operations-management_mobile.json": 666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7178;